import script from "./SideMenuBase.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenuBase.vue?vue&type=script&setup=true&lang=js"

import "./SideMenuBase.vue?vue&type=style&index=0&id=26580b80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26580b80"]])

export default __exports__